import { render, staticRenderFns } from "./ObjectsInfo.vue?vue&type=template&id=f8f2f78a"
import script from "./ObjectsInfo.vue?vue&type=script&lang=js"
export * from "./ObjectsInfo.vue?vue&type=script&lang=js"
import style0 from "./ObjectsInfo.vue?vue&type=style&index=0&id=f8f2f78a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports